import type { SVGProps } from "react";
const SvgCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M612.707 182.293C613.098 182.683 613.098 183.317 612.707 183.707L602.707 193.707C602.317 194.098 601.683 194.098 601.293 193.707L596.293 188.707C595.902 188.317 595.902 187.683 596.293 187.293C596.683 186.902 597.317 186.902 597.707 187.293L602 191.586L611.293 182.293C611.683 181.902 612.317 181.902 612.707 182.293Z"
      fill="currentColor"
      transform="translate(-592 -176)"
    />
  </svg>
);
export default SvgCheck;
